import { render, staticRenderFns } from "./RegistrationsProgressItem.vue?vue&type=template&id=10b6024c&"
import script from "./RegistrationsProgressItem.vue?vue&type=script&lang=ts&"
export * from "./RegistrationsProgressItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports